import ThemifyIconContainer from "../../components/icon/themifyIcon";

const ThemifyIcon = () => {
  return <ThemifyIconContainer />;
};

export default ThemifyIcon;
